module.exports = __webpack_public_path__ + "static/media/TM.fd7246b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TM.svg
// module id = 375
// module chunks = 0